import axios from 'axios'

export default {
    async fetchAll() {
        const response = await axios.get('/api/target_builds');
        return response.data;
    },
    async fetchBranches() {
        const response = await axios.get('/api/branches');
        return response.data.branches;
    },
    async fetchMtrSummaryForTargetBuild(targetBuildId) {
        const response = await axios.get(`/api/target_builds/${targetBuildId}/mtr_summary`);
        return response.data;
    },
    async fetchTargetBuildDetails(targetBuildId) {
      const response = await axios.get(`/api/target_builds/${targetBuildId}`);
      return response.data
    },
    async fetchMtrNames() {
        const response = await axios.get('/api/mtr_names');
        return response.data.mtr_names;
    },
    async fetchProducts() {
        const response = await axios.get('/api/products');
        return response.data.products;
    },
    async fetchCiServices() {
        const response = await axios.get('/api/ci_services');
        return response.data.ci_services;
    },
    async fetchHistory(params = {}) {
        const response = await axios.get('/api/target_build_history', { params });
        return response.data;
    },
    async fetchTargetByName(name) {
        const response = await axios.get(`/api/target_id_by_name/${name}`);
        return response.data.target_id;
    },
    async fetchBuildTypes() {
        const response = await axios.get('/api/build_types');
        return response.data.build_types;
    },
    async fetchAdditionalTools() {
        const response = await axios.get('/api/additional_tools');
        return response.data.additional_tools;
    },
    async dropTargetBuild(target_build_id) {
        return axios.post('/api/drop_target_build', {target_build_id});
    },
    async dropTestCasesForTarget(target_build_id, dates, time_interval) {
        return axios.post('/api/drop_test_cases_for_target', {target_build_id, dates, time_interval});
    },
}
